import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import "./Service2.css";

import parrotImg from "../images/article-parrot.jpeg";
import swanImg from "../images/article-swan.jpeg";
import peacockImg from "../images/article-peacock.jpeg";

const articles = [
  {
    id: 1,
    title: "The Intelligence of Parrots",
    image: parrotImg,
    content:
      "Parrots are among the most intelligent bird species. They can mimic human speech and even understand context in some cases. Their social behavior and problem-solving abilities are fascinating to observe.",
  },
  {
    id: 2,
    title: "Migration Patterns of Swans",
    image: swanImg,
    content:
      "Swans migrate over thousands of kilometers every year, often returning to the same nesting grounds. These graceful birds rely on celestial navigation and environmental cues during their long journeys.",
  },
  {
    id: 3,
    title: "The Colorful World of Peacocks",
    image: peacockImg,
    content:
      "Peacocks are famous for their iridescent tail feathers, which they fan out in displays of beauty and dominance. The vibrant colors come from microscopic structures that reflect light in different ways.",
  },
];

function Service2() {
  const [comments, setComments] = useState([]);
  const [formData, setFormData] = useState({ name: "", message: "" });

  // Fetch comments from backend on mount
  useEffect(() => {
    fetch("http://localhost:5000/api/service2/comments")
      .then((res) => res.json())
      .then((data) => setComments(data || []))
      .catch((err) => console.error(err));
  }, []);

  // Handle form input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit comment to backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.message.trim()) return alert("Enter your name and comment!");

    try {
      const res = await fetch("http://localhost:5000/api/service2/comment", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const newComment = await res.json();
      setComments([newComment, ...(comments || [])]);
      setFormData({ name: "", message: "" });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="service2-page">
    

      {/* Articles Section */}
      <section className="articles-section">
        <h1>Educational Articles About Birds</h1>
        <p className="intro">
          Explore fascinating facts and insights about the wonderful world of birds.
        </p>

        <div className="articles-grid">
          {(articles || []).map((article) => (
            <div className="article-card" key={article.id}>
              <img src={article.image} alt={article.title} />
              <h3>{article.title}</h3>
              <p>{article.content}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Comments Section */}
      <section className="comments-section">
        <h2>Share Your Thoughts</h2>

        <form className="comment-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Write your comment..."
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit">Post Comment</button>
        </form>

        <div className="comment-list">
          {(comments || []).length === 0 ? (
            <p className="no-comments">No comments yet. Be the first!</p>
          ) : (
            (comments || []).map((c) => (
              <div key={c._id || c.id} className="comment">
                <h4>{c.name}</h4>
                <small>{new Date(c.date).toLocaleString()}</small>
                <p>{c.message}</p>
              </div>
            ))
          )}
        </div>
      </section>

      
    </div>
  );
}

export default Service2;

